import script from "./InspectionGroupCreateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionGroupCreateForm.vue?vue&type=script&lang=ts&setup=true"

import "./InspectionGroupCreateForm.vue?vue&type=style&index=0&id=d85d17aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85d17aa"]])

export default __exports__